export default "__VITE_ASSET__C5YaA1Pi__"